import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { InfoCircleLightGlyph } from '@acast-tech/decibel-glyphs';
import T from 'prop-types';
import { forwardRef } from 'react';
import { Box } from '../Box/Box';
import { Icon } from '../Icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TooltipIndicator = /*#__PURE__*/forwardRef(function TooltipIndicator(_ref, forwardedRef) {
  let {
    glyph = InfoCircleLightGlyph,
    children
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["glyph", "children"]);

  return /*#__PURE__*/_jsxs(Box, Object.assign({}, restProps, {
    ref: forwardedRef,
    display: "inline-flex",
    as: "span",
    children: [glyph && /*#__PURE__*/_jsx(Icon, {
      glyph: glyph,
      size: "xsmall",
      mr: children ? 1 : null
    }), children]
  }));
});
TooltipIndicator.propTypes = {
  glyph: T.elementType,
  children: T.node
};
export { TooltipIndicator };